import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createSchemaRequest = { schema: '_schema' };
var _createSchemaResponse = { schema: '_schema' };
var _deleteSchemaRequest = {};
var _deleteSchemaResponse = {};
var _getSchemaByKeyRequest = {};
var _getSchemaByKeyResponse = { schema: '_schema' };
var _getSchemaRequest = {};
var _getSchemaResponse = { schema: '_schema' };
var _listSiteSchemasRequest = {};
var _listSiteSchemasResponse = { schemas: '_schema' };
var _querySchemasRequest = {};
var _querySchemasResponse = { schemas: '_schema' };
var _schema = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    fields: 'Map#_schemaField',
};
var _schemaField = { index: 'google.protobuf.DoubleValue' };
var _updateSchemaRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    schema: '_schema',
};
var _updateSchemaResponse = { schema: '_schema' };
function resolveWixMultilingualTranslationSchemaV1TranslationSchemaUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/translation-schema',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/translation-schema',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/translation-schema',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/translation-schema',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/translation-schema',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/translation-schema',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/translation-schema',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a Schema.
 *
 * The request body must include schema key and fields.
 */
export function createSchema(payload) {
    var _a = serializer(_createSchemaRequest, { _schema: _schema, _schemaField: _schemaField }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createSchemaResponse, {
        _schema: _schema,
        _schemaField: _schemaField,
    }).fromJSON;
    function __createSchema(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.schema',
            method: 'POST',
            methodFqn: 'wix.multilingual.translation.schema.v1.TranslationSchema.CreateSchema',
            url: resolveWixMultilingualTranslationSchemaV1TranslationSchemaUrl({
                protoPath: '/v1/schemas',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSchema.fromReq = fromReq;
    __createSchema.__isAmbassador = true;
    return __createSchema;
}
/** Retrieves a Schema. */
export function getSchema(payload) {
    var _a = serializer(_getSchemaRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSchemaResponse, {
        _schema: _schema,
        _schemaField: _schemaField,
    }).fromJSON;
    function __getSchema(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.schema',
            method: 'GET',
            methodFqn: 'wix.multilingual.translation.schema.v1.TranslationSchema.GetSchema',
            url: resolveWixMultilingualTranslationSchemaV1TranslationSchemaUrl({
                protoPath: '/v1/schemas/{schemaId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSchema.fromReq = fromReq;
    __getSchema.__isAmbassador = true;
    return __getSchema;
}
/** Retrieves a Schema by key. */
export function getSchemaByKey(payload) {
    var _a = serializer(_getSchemaByKeyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSchemaByKeyResponse, {
        _schema: _schema,
        _schemaField: _schemaField,
    }).fromJSON;
    function __getSchemaByKey(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.schema',
            method: 'GET',
            methodFqn: 'wix.multilingual.translation.schema.v1.TranslationSchema.GetSchemaByKey',
            url: resolveWixMultilingualTranslationSchemaV1TranslationSchemaUrl({
                protoPath: '/v1/schemas/app-id/{key.appId}/entity-type/{key.entityType}/scope/{key.scope}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSchemaByKey.fromReq = fromReq;
    __getSchemaByKey.__isAmbassador = true;
    return __getSchemaByKey;
}
/** Updates a Schema. */
export function updateSchema(payload) {
    var _a = serializer(_updateSchemaRequest, { _schema: _schema, _schemaField: _schemaField }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSchemaResponse, {
        _schema: _schema,
        _schemaField: _schemaField,
    }).fromJSON;
    function __updateSchema(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.schema',
            method: 'PATCH',
            methodFqn: 'wix.multilingual.translation.schema.v1.TranslationSchema.UpdateSchema',
            url: resolveWixMultilingualTranslationSchemaV1TranslationSchemaUrl({
                protoPath: '/v1/schemas/{schema.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSchema.fromReq = fromReq;
    __updateSchema.__isAmbassador = true;
    return __updateSchema;
}
/** Deletes a Schema. */
export function deleteSchema(payload) {
    var _a = serializer(_deleteSchemaRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteSchemaResponse, {}).fromJSON;
    function __deleteSchema(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.schema',
            method: 'DELETE',
            methodFqn: 'wix.multilingual.translation.schema.v1.TranslationSchema.DeleteSchema',
            url: resolveWixMultilingualTranslationSchemaV1TranslationSchemaUrl({
                protoPath: '/v1/schemas/{schemaId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteSchema.fromReq = fromReq;
    __deleteSchema.__isAmbassador = true;
    return __deleteSchema;
}
/** Retrieves a list of Schemas, given the provided [paging, filtering, and sorting][1]. */
export function querySchemas(payload) {
    var _a = serializer(_querySchemasRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_querySchemasResponse, {
        _schema: _schema,
        _schemaField: _schemaField,
    }).fromJSON;
    function __querySchemas(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.schema',
            method: 'POST',
            methodFqn: 'wix.multilingual.translation.schema.v1.TranslationSchema.QuerySchemas',
            url: resolveWixMultilingualTranslationSchemaV1TranslationSchemaUrl({
                protoPath: '/v1/schemas/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __querySchemas.fromReq = fromReq;
    __querySchemas.__isAmbassador = true;
    return __querySchemas;
}
/** Retrieves a list of Schemas of app installed on site. */
export function listSiteSchemas(payload) {
    var _a = serializer(_listSiteSchemasRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSiteSchemasResponse, {
        _schema: _schema,
        _schemaField: _schemaField,
    }).fromJSON;
    function __listSiteSchemas(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.schema',
            method: 'GET',
            methodFqn: 'wix.multilingual.translation.schema.v1.TranslationSchema.ListSiteSchemas',
            url: resolveWixMultilingualTranslationSchemaV1TranslationSchemaUrl({
                protoPath: '/v1/schemas/site',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSiteSchemas.fromReq = fromReq;
    __listSiteSchemas.__isAmbassador = true;
    return __listSiteSchemas;
}
//# sourceMappingURL=http.impl.js.map